
import React from "react";
/**
 * Validate input OTP Component
 */
class ValidateOtp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      OTP: "",
      email: props.email
    };
  }

  /**Render Method for OTP Field */
  render() {
    let output = this.props.phoneNumber?.toString().substring(6, 10);

    output = output ? "XXXXXX" + output : null;
    return (
      <div>
        <div>
          {output && output.length > 0 ? (
            <p style={{ lineHeight: "1.3" }}>
              {" "}
              {"Please enter the One Time Password (OTP) sent to your registered\r"}
              {"email address "}{this.state.email}{" and cell phone number "}{output}{".\r"}
            </p>
          ) : (
            <p style={{ lineHeight: "1.3" }}>
              {" "}
              {"Please enter the One Time Password (OTP) sent to your registered\r"}
              {"email address "}{this.state.email}
            </p>
          )}
          <label>{"One Time Password (OTP) "}</label>
          <br />
          <input
            type={"number"}
            maxLength={"4"}
            name={"OTP"}
            onBlur={(e) => this.setState({ OTP: e.target.value })}
            className={"text-field "}
            onCopy={"return false"}
            onPaste={() => { return false }}
          />
        </div>

        <div>
          <button type={"button"}
            className={"login-button"}
            onClick={() => this.props.verifyOTP(this.state.OTP)}
          >
            {"Validate OTP\r"}
          </button>
        </div>
        <div className={"w-100"} style={{ paddingTop: "9px" }}>
          <span
            className={"pointer"}
            onClick={() => this.props.resendOTP("string")}
          >
            {"Resend OTP\r"}
          </span>
        </div>
      </div>
    );
  }
}

export default ValidateOtp;
